<template>
  <router-view />
</template>

<script>
export default {
  name: 'MenuView',
};
</script>
